type Zone = {
  name: string;
  description: string;
  color: string;
};

const zone: Zone = {
  name: "",
  description: "",
  color: "",
};

export type { Zone };

export { zone };
